import { ChangeEvent } from "react";
import { faUndo } from "@fortawesome/free-solid-svg-icons/faUndo";
import { resources } from "@constants/hardcoded-strings";
import { TextareaFormGroup } from "@containers/common/textarea-form-group/textarea-form-group";
import { LabelWidthTypes } from "@enums/label-width-types";
import { LayoutTypes } from "@enums/layout-types";
import { ThemingGenericContentSlotValidationErrors } from "@idw-types/common/validation/common/theming-validation-errors";

type ContentSlotExplicitConsentContainerProps = {
    isDisabled: boolean;
    layout: LayoutTypes;
    labelWidth: LabelWidthTypes;
    validationErrors: ThemingGenericContentSlotValidationErrors;
    explicitConsentMessage: string;
    defaultExplicitConsentMessage: string;
    updateAXNUIContentExplicitConsentMessage: (explicitConsentMessage: string) => void;
};

export const ContentSlotExplicitConsentContainer = (props: ContentSlotExplicitConsentContainerProps) => {
    const {
        isDisabled,
        layout,
        labelWidth,
        validationErrors,
        explicitConsentMessage,
        defaultExplicitConsentMessage,
        updateAXNUIContentExplicitConsentMessage
    } = props;

    const handleExplicitConsentMessageChange = (event: ChangeEvent<HTMLInputElement>) => {
        updateAXNUIContentExplicitConsentMessage(event.target.value)
    };

    const handleResetExplicitConsentMessage = () => {
        updateAXNUIContentExplicitConsentMessage(defaultExplicitConsentMessage)
    };

    return (
        <div>
            <TextareaFormGroup
                controlId={"content-slot-explicit-consent-input"}
                automationId={"content-slot-explicit-consent-input"}
                label={resources.pages.verificationServiceDetails.tabs.theming.subTabs.common.inputs.explicitConsent.label}
                ariaLabel={resources.pages.verificationServiceDetails.tabs.theming.subTabs.common.inputs.explicitConsent.label}
                layout={layout}
                labelWidth={labelWidth}
                onChange={handleExplicitConsentMessageChange}
                value={explicitConsentMessage || ""}
                disabled={isDisabled}
                isRequired={true}
                afterLabelTooltipText={resources.pages.verificationServiceDetails.tabs.theming.subTabs.common.inputs.explicitConsent.tooltip}
                afterLabelIcon={isDisabled ? null : faUndo}
                afterLabelIconOnClick={handleResetExplicitConsentMessage}
            />
            {validationErrors.explicitConsentError}
        </div>
    );
};